import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe, Sparkles, Share2, Eye, Map } from 'lucide-react';
import SEO from './SEO';
import PageHeader from './PageHeader';

const AgencyFeatures = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem('tweeporter_user_tier', 'agency');
    window.scrollTo(0, 0);
  }, []);

  const proFeatures = [
    {
      title: 'Visual Editor',
      description: 'Node-based visual story editor.',
      icon: Eye,
      action: () => navigate('/visual-editor?starter=true'),
      tag: 'PRO'
    },
    {
      title: 'Visual Story Planner',
      description: 'Plan complex narratives with chapters.',
      icon: Sparkles,
      action: () => navigate('/visual-story-planner'),
      tag: 'PRO'
    },
    {
      title: 'Shared Story (Beta)',
      description: 'Live interactive multi-user sessions.',
      icon: Share2,
      action: () => navigate('/compiler'),
      tag: 'PRO'
    }
  ];

  const agencyFeatures = [
    {
      title: 'Sitemap to PathNav (Beta)',
      description: 'Convert any website sitemap into an interactive navigation mind map.',
      icon: Globe,
      action: () => navigate('/sitemap-to-pathnav'),
      tag: 'AGENCY'
    },
    {
      title: 'Customer Journey Wizard',
      description: 'Build guided customer journeys with AI assistance.',
      icon: Map,
      action: () => navigate('/journey-wizard'),
      tag: 'AGENCY'
    }
  ];

  const FeatureCard = ({ feature, large }) => (
    <div
      className={`bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all cursor-pointer group ${large ? '' : ''}`}
      onClick={feature.action}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center group-hover:scale-110 transition-transform">
          <feature.icon className="w-5 h-5 text-white" />
        </div>
        <span className={`px-2 py-0.5 text-xs font-bold rounded ${feature.tag === 'AGENCY' ? 'bg-amber-600 text-white' : 'bg-purple-600 text-white'}`}>
          {feature.tag}
        </span>
      </div>
      <h3 className="text-lg font-bold text-white mb-1">{feature.title}</h3>
      <p className="text-amber-200 text-sm">{feature.description}</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-900 via-orange-900 to-slate-900">
      <SEO title="Agency Features - TweePorter" />
      
      <PageHeader lightText={true} />

      <div className="container mx-auto px-4 py-12">
        {/* Page headline */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-amber-600 text-white text-sm font-bold rounded-full mb-4">
            AGENCY
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Agency Suite
          </h1>
          <p className="text-xl text-amber-200 max-w-2xl mx-auto">
            Enterprise tools for agencies and teams building client experiences.
          </p>
        </div>

        {/* Agency Features */}
        <div className="mb-12">
          <h2 className="text-xl font-bold text-amber-300 mb-4">Agency Tools</h2>
          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {agencyFeatures.map((feature, index) => (
              <FeatureCard key={index} feature={feature} large />
            ))}
          </div>
        </div>

        {/* PRO Features included */}
        <div>
          <h2 className="text-xl font-bold text-purple-300 mb-4">Includes All PRO Features</h2>
          <div className="grid md:grid-cols-3 gap-4 max-w-4xl mx-auto">
            {proFeatures.map((feature, index) => (
              <FeatureCard key={index} feature={feature} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyFeatures;
